import { render, staticRenderFns } from "./homev2.vue?vue&type=template&id=7dfd784f&scoped=true&"
import script from "./homev2.vue?vue&type=script&lang=js&"
export * from "./homev2.vue?vue&type=script&lang=js&"
import style0 from "./homev2.vue?vue&type=style&index=0&id=7dfd784f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfd784f",
  null
  
)

export default component.exports